import { CONSUMPTION_INCIDENCE_QUESTION_TYPE, getQuestionsFromJson, MULTI_SELECT_QUESTION_TYPE, RANGE_CONSUMPTION_QUESTION_TYPE, RANK_QUESTION_TYPE, SINGLE_SELECT_QUESTION_TYPE, SUB_QUESTIONS_LIST, SURVEY_OPTION_TYPES, SURVEY_OTHER_OPTION_TEXT } from "../surveyHelper";
import get from "lodash/get";
import { getInteractionsData } from "../tastingHelper";
export const FILL_UI_TYPES = {
    SINGLE: "single_question_view",
    MULTI: "multi_question_view"
};

export const CURRENT_STATUS = {
    SUBMIT: 2,
    PARTIAL: 3,
};

const ACTION_TEXTS = {
    JUMP: 'jump',
    END_SURVEY: 'end_survey'
};

//null, answers, currentQuestionId, form, isSectionInside
export function MandatoryError(question, answers) {
    if (!question) return;
    const questionId = Number(question.id);

    // Determine if the question is mandatory
    const isMandatory = Number(question.is_mandatory) === 1;

    if (!isMandatory) return false; // q is non mandatory

    const response = answers.get(questionId);

    // If the answer is not present at all
    if (!answers.has(questionId)) {
        return true;
    }

    if (!response.length) {
        return true;
    }

    // If it's a mandatory rank question and not all ranks are filled
    if (
        Number(question.question_type) === RANK_QUESTION_TYPE &&
        response.filter(each => !!each).length !== Number(question.max)
    ) {
        return true;
    }
    // If it's a mandatory consumption incidence  and not all values are equal to 100
    if (
        Number(question.question_type) === CONSUMPTION_INCIDENCE_QUESTION_TYPE
    ) {
        const anyOtherOption = response.find(_ => Number(_.option_type) === SURVEY_OPTION_TYPES.ANY_OTHER);
        if(anyOtherOption && Number(get(anyOtherOption , "percentage" , 0)) > 0 && !get(anyOtherOption, "value", false)) return true;
        if(addNumberValue(response.map(_ => Number(get(_,"percentage",0)))) !== 100 ) return true;
    }

    // If it's a mandatory important satisfaction question and not all subquestions are filled
    if (
       (SUB_QUESTIONS_LIST.includes(Number(question.question_type))) &&
        response.filter(each => !!each).length !== Number(question.sub_questions.length)
    ) {
        return true;
    }

    return false;
};

export function checkForValidAnswers(isSectionInside, form, showSectionIndex, answers) {
    let isValid = true;
    const mandatoryQuestionsUnfilled = [];

    const questionsToUse = isSectionInside
        ? form[showSectionIndex].questions
        : form;

    questionsToUse.forEach((question, index) => {


        if (MandatoryError(question, answers)) {
            isValid = false;
            mandatoryQuestionsUnfilled.push(index + 1); // 1-based index
        }
    });

    return {
        isValid,
        unfilled: mandatoryQuestionsUnfilled
    };
};

function formatOptions(type, options) {
    if (type === MULTI_SELECT_QUESTION_TYPE || type === SINGLE_SELECT_QUESTION_TYPE) {
        return options.map((option) => {
            if (Number(option.option_type) !== SURVEY_OPTION_TYPES.ANY_OTHER) {
                return option;
            }
            return {
                ...option,
                value: option.value || SURVEY_OTHER_OPTION_TEXT
            };
        });
    }

    return options.filter((option) => option !== "");
};

export function formatQuestionPayload({ form = {}, answers, isSectionInside, showSectionIndex, isSingleView, currentQuestion = [] , logs = {} }) {
    let questions;
    if (isSingleView) {
        questions = [currentQuestion];
    } else {
        questions = isSectionInside ? (form[showSectionIndex].questions || []) : form;
    }
    return questions.map((question) => {
        const questionId = Number(question.id);
        const questionType = Number(question.question_type);
        const currentOptions = answers.get(Number(questionId)) || [];
        const subQuestions = question.hasOwnProperty("sub_questions") ? question.sub_questions : null;
        const interactions = logs[question.id];

        const optionTimestamps = interactions ? interactions.option_selected_at : {};        
        const options = formatOptions(questionType, currentOptions);

        const result = {
            question_id: questionId,
            question_type_id: questionType,
            ...(interactions && {...getInteractionsData(interactions)})
        };

        if (subQuestions) {
            result.sub_questions = subQuestions;
            result.logs = logs;
        }

        if (options.length) {
            let enrichedOptions = null;
            if (optionTimestamps && Object.values(optionTimestamps) && Object.values(optionTimestamps).length) {
                enrichedOptions = options.map(function (opt) {
                    if (optionTimestamps.hasOwnProperty(opt.id)) {
                        return {
                            ...opt,
                            selected_at: optionTimestamps[opt.id]
                        };
                    }
                    return opt;
                });
            }
            result.options = enrichedOptions ? enrichedOptions : options;
        }

        return result;
    });
};

export function findQuestionById(form, questionId, isSection) {    
    if (!form || !questionId) return {};
    if (isSection) {
        for (const section of form) {
            const question = (section.questions || []).find(q => Number(q.id) === Number(questionId));
            if (question) {
                const { questions = [], ...sectionMeta } = section;
                return { question, section: { ...sectionMeta , questions:  questions.map(q => Number(q.id)) } };
            }
        }
        return null;
    } else {
        const question = form.find(q => Number(q.id) === Number(questionId)) || null;
        return { question, section: null };
    }
};

export function calculateProgressToLastQuestion({
    form,
    currentQuestionId,
    currentSectionId,
    isSectionInside
}) {
    if (!form) return 0;

    let allItems = [];

    if (isSectionInside) {
        for (const section of form) {
            const questions = section.questions || [];
            if (questions.length > 0) {
                allItems.push(...questions);
            } else {
                // Treat empty section as a step with synthetic ID
                allItems.push({ id: `empty-section-${section.id}`, _sectionId: section.id });
            }
        }
    } else {
        allItems = form;
    }

    const totalItems = allItems.length;

    // Find index based on currentQuestionId or currentSectionId
    const currentIndex = allItems.findIndex(item => {
        if (currentQuestionId) {
            return String(item.id) === String(currentQuestionId);
        }
        if (currentSectionId) {
            // Match section placeholder step
            return item._sectionId && String(item._sectionId) === String(currentSectionId);
        }
        return false;
    });

    const progress = currentIndex >= 0 && totalItems > 0
        ? ((currentIndex + 1) / totalItems) * 100
        : 0;

    return progress;
}

export function isFirstQuestion({ currentQuestionId, form, isSectionInside , currentSectionId }) {
    const firstSection = isSectionInside ? form[0] : "";
    const {section} = findQuestionById(form , currentQuestionId , isSectionInside);

    const isCurrentFirstSection = Number(firstSection.id) === Number(section ? section.id : currentSectionId);
    const isFirstSectionHasQuestions = firstSection && firstSection.questions && firstSection.questions.length === 0;
    const flatQuestions = isSectionInside
        ? form.flatMap(section => section.questions || [])
        : form;
    if (!flatQuestions.length) return true; // treat as first if form is empty

    const firstQuestion = flatQuestions[0];

    if (isSectionInside) {
        return isCurrentFirstSection && (isFirstSectionHasQuestions || Number(firstQuestion.id) === Number(currentQuestionId))
    } else {
        return Number(firstQuestion.id) === Number(currentQuestionId);
    }

}

export function isLastQuestionOrLastEmptySection({ form, currentQuestionId, isSectionInside, currentSectionId }) {
    if (isSectionInside) {
        const lastSectionIndex = form.length - 1;

        const currentSectionIndex = form.findIndex(
            section => Number(section.id) === Number(currentSectionId)
        );

        if (currentSectionIndex === -1) {
            return false;
        }

        const isLastSection = currentSectionIndex === lastSectionIndex;
        const currentSection = form[currentSectionIndex];
        const questions = currentSection.questions || [];

        // Case 1: Last section and it's empty
        if (isLastSection && questions.length === 0) {
            return true;
        }

        // Case 2: Last question in last section
        if (isLastSection && questions.length > 0) {
            const lastQuestionInSection = questions[questions.length - 1];
            return Number(lastQuestionInSection.id) === Number(currentQuestionId);
        }

        // Any other case
        return false;
    } else {
        // Non-sectioned: flat list of questions
        const currentIndex = form.findIndex(q => Number(q.id) === Number(currentQuestionId));
        return currentIndex === form.length - 1;
    }
}

const isEmptySection = (form , currentSectionId) => {
    const targetSection  = form.find(section => Number(section.id) === Number(currentSectionId));
    return targetSection;
}


export function getCurrentStatusId({ form, currentQuestionId, answers, isSectionInside, currentSectionId }) {
    // final submit 2 
    // for partial use 3
    if (isLastQuestionOrLastEmptySection({ form, currentQuestionId, isSectionInside, currentSectionId })) return CURRENT_STATUS.SUBMIT; // submit - last question
    const { question , section } = findQuestionById(form, currentQuestionId, isSectionInside); 
    const isSectionEmpty = isEmptySection(form , currentSectionId); 
    if (isSectionEmpty && isSectionEmpty.questions && isSectionEmpty.questions.length === 0 && isSectionEmpty.outgoing_condition &&
        isSectionEmpty.outgoing_condition.action &&
        isSectionEmpty.outgoing_condition.action === ACTION_TEXTS.END_SURVEY) {
        return CURRENT_STATUS.SUBMIT
    }
    if (question || section) {
        const answer = answers.get(Number(currentQuestionId))
        const firstOption = Array.isArray(answer) ? answer[0] : null;

         if (firstOption &&
            firstOption.outgoing_condition &&
            firstOption.outgoing_condition.action &&
            firstOption.outgoing_condition.action === ACTION_TEXTS.END_SURVEY) {
            return CURRENT_STATUS.SUBMIT; // submit - selected option has end_survey condition
        }

        if (question.outgoing_condition &&  question.outgoing_condition.action &&
            question.outgoing_condition.action === ACTION_TEXTS.END_SURVEY) {
            return CURRENT_STATUS.SUBMIT;
        }

        const isLastQuestionOfSection = isLastQuestionFromSection(currentQuestionId, section, isSectionInside);

        // Handle jump logic if section has outgoing condition and current question is last question from that section 
        if (isLastQuestionOfSection && section && section.outgoing_condition && section.outgoing_condition.action &&
            section.outgoing_condition.action === ACTION_TEXTS.END_SURVEY) {
            return CURRENT_STATUS.SUBMIT;
        }
       
    }
    return CURRENT_STATUS.PARTIAL; // partial - for rest all cases
};

export function findFirstQuestionBySectionId(form, sectionId) {
    // Find the section with matching id
    const section = form.find(sec => Number(sec.id) === Number(sectionId));
    if (!section || !Array.isArray(section.questions) || section.questions.length === 0) {
        return null; // no section found or no questions in section
    }

    // Return the first question
    return section.questions[0];
};


const getNextQuestionIdByJumpLogic = (target , form) => {
     const { action, section_id, question_id } = target.outgoing_condition;

        if (action === ACTION_TEXTS.JUMP) {
            if (question_id !== undefined) {
                return Number(question_id);
            }
            if (section_id !== undefined) {
                const firstQuestion = findFirstQuestionBySectionId(form, section_id);
                if (firstQuestion !== null) {
                    return Number(firstQuestion.id);
                } else {
                    return '__EMPTY_SECTION__'; // No questions in target section
                }
            }
            return null;
        }
}

const isLastQuestionFromSection = (questionId, currentSection , isSection) => {
    if (isSection && currentSection && currentSection.questions && !!currentSection.questions.length) {
        const lastQuestionId = currentSection.questions[currentSection.questions.length - 1];
        if (Number(lastQuestionId) === Number(questionId)) return true;
    };

    return false;
}

export function getNextQuestionId({ answers, currentQuestionId, currentSectionId, form, isSectionInside }) {
    if (!answers) return null;

    const answer = answers.get(Number(currentQuestionId));
    const firstOption = Array.isArray(answer) ? answer[0] : null;

    // get current question data
    const currentQuestion = findQuestionById(form , currentQuestionId , isSectionInside);    

    const {section} = currentQuestion;    

    // cheking for current question is last question or not 
    const isLastQuestionOfSection = isLastQuestionFromSection(currentQuestionId , section , isSectionInside);
    const isSectionEmpty = isEmptySection(form , currentSectionId);
    
    // if current section is empty and it jump to another section or question
    if (isSectionEmpty && isSectionEmpty.questions && isSectionEmpty.questions.length === 0) {
        if (
            isSectionEmpty.outgoing_condition &&
            Object.keys(isSectionEmpty.outgoing_condition).length > 0
        ) {
           return getNextQuestionIdByJumpLogic(isSectionEmpty , form);
        }
    }
    // Handle jump logic
    if (firstOption && firstOption.outgoing_condition && Object.keys(firstOption.outgoing_condition).length > 0) {
         return getNextQuestionIdByJumpLogic(firstOption , form);
    }


      // Handle jump logic if question has outgoing condition
    if (currentQuestion.question && currentQuestion.question.outgoing_condition && Object.keys(currentQuestion.question.outgoing_condition).length > 0) {
       return getNextQuestionIdByJumpLogic(currentQuestion.question , form);
    }

    // Handle jump logic if section has outgoing condition and current question is last question from that section 
    if(isLastQuestionOfSection && currentQuestion.section && currentQuestion.section.outgoing_condition && Object.keys(currentQuestion.section.outgoing_condition).length > 0){
       return getNextQuestionIdByJumpLogic(currentQuestion.section , form);
    }

    // No jump — find next sequential question
    if (isSectionInside) {
        // Case 1: We have a current question - find next question or next section
        if (currentQuestionId !== null) {
            let foundCurrent = false;

            for (let i = 0; i < form.length; i++) {
                const section = form[i];
                const { questions } = section;

                for (let j = 0; j < questions.length; j++) {
                    const q = questions[j];

                    if (Number(q.id) === Number(currentQuestionId)) {
                        foundCurrent = true;

                        // If not last question in current section, return next question
                        if (j + 1 < questions.length) {
                            return questions[j + 1].id;
                        }
                        // Last question in section - check next sections
                        break;
                    }
                }

                if (foundCurrent) {
                    // After finishing current section, find next non-empty section
                    for (let k = i + 1; k < form.length; k++) {
                        const nextSection = form[k];
                        if (nextSection.questions.length === 0) {
                            return '__EMPTY_SECTION__';
                        } else {
                            return nextSection.questions[0].id;
                        }
                    }
                    return null; // No more sections
                }
            }
        }

        // Case 2: We're at section level (from EMPTY_SECTION state) - find next section
        if (currentSectionId !== null) {
            const currentSectionIndex = form.findIndex(section => Number(section.id) === Number(currentSectionId));

            if (currentSectionIndex !== -1 && currentSectionIndex + 1 < form.length) {
                const nextSection = form[currentSectionIndex + 1];
                if (nextSection.questions.length === 0) {
                    return '__EMPTY_SECTION__';
                }
                return Number(nextSection.questions[0].id);
            }
        }

        return null;
    }
    else {
        // Non-section case - flat structure
        const currentIndex = form.findIndex(q => Number(q.id) === Number(currentQuestionId));
        if (currentIndex !== -1 && currentIndex + 1 < form.length) {
            return Number(form[currentIndex + 1].id);
        }
    }

    return null;
}


export function getSectionIdByOutgoingCondition({answer, form, currentQuestion ,isSectionInside,currentSectionId}) {
    // Step 1: Check for section_id from outgoing_condition
    var firstOption = Array.isArray(answer) ? answer[0] : null;
    const isSectionEmpty = isEmptySection(form , currentSectionId);
    
    // if current section is empty and it jump to empty section
    if (isSectionEmpty && isSectionEmpty.questions && isSectionEmpty.questions.length === 0) {
        if (
            isSectionEmpty.outgoing_condition &&
            typeof isSectionEmpty.outgoing_condition.section_id !== 'undefined'
        ) {
            return Number(isSectionEmpty.outgoing_condition.section_id);
        }
    }
    
    if (
        firstOption &&
        firstOption.outgoing_condition &&
        typeof firstOption.outgoing_condition.section_id !== 'undefined'
    ) {
        return Number(firstOption.outgoing_condition.section_id);
    }

    // if it jump to empty section from question
    if (
        currentQuestion &&
        currentQuestion.outgoing_condition &&
        typeof currentQuestion.outgoing_condition.section_id !== 'undefined'
    ) {
        return Number(currentQuestion.outgoing_condition.section_id);
    }

    // if current question is last question of section and section jump to empty section
    if (currentQuestion) {
        const currentQuestion1 = findQuestionById(form, currentQuestion.id, isSectionInside);
        const { section } = currentQuestion1;
        const isLastQuestionOfSection = isLastQuestionFromSection(currentQuestion.id, section, isSectionInside);
            if (
            isLastQuestionOfSection &&
            section &&
            section.outgoing_condition &&
            typeof section.outgoing_condition.section_id !== 'undefined'
        ) {
            return Number(section.outgoing_condition.section_id);
        }
    }
    


    // Step 2: Fallback to next section based on currentSectionId
    const currentSectionIndex = form.findIndex(
        section => Number(section.id) === Number(currentSectionId)
    );

    if (currentSectionIndex !== -1 && currentSectionIndex + 1 < form.length) {
        const nextSection = form[currentSectionIndex + 1];
        return Number(nextSection.id);
    }
    return null;
}

export function getFirstQuestionId({ form, isSectionInside }) {
    if(isSectionInside){
        if(form[0] && form[0].questions && form[0].questions.length === 0){
            return {"sectionId": form[0].id};
        }
    }
     
    const allQuestions = isSectionInside ? form.flatMap(section => section.questions || []) : form;
    return allQuestions.length ? Number(allQuestions[0].id) : null
}


// function for getting number from string for percentage key
export const normalizePercentage = (value) => {    
  if (typeof value === "string") {
    return Number(value.replace("%", ""));
  }
  return Number(value);
};


// function for adding number values from array
export function addNumberValue(arr) {
    return arr.reduce((acc , _) => acc + _ , 0);
}

// function for validate of incidence question
export const validateConsumptionIncidence = (
    isSectionInside,
    form,
    showSectionIndex,
    answers,
    isSingleView,
    currentQuestion
) => {
    let questions = [];
    let isInValid = false;

    if (!isSingleView) {
        if (isSectionInside) {
            const currentSection = form[showSectionIndex];
            questions = get(currentSection, "questions", []);
            if (!questions.length) return false; // no error
        } else {
            questions = form || [];
        }
    }


    const consumptionIncidenceQuestion = isSingleView ? currentQuestion : questions.find(
        (q) => Number(q.question_type) === Number(CONSUMPTION_INCIDENCE_QUESTION_TYPE)
    );

    if (!consumptionIncidenceQuestion) return {isInValid : false , text : ""};

    if (isSingleView && Number(get(consumptionIncidenceQuestion,"question_type", 0)) !== Number(CONSUMPTION_INCIDENCE_QUESTION_TYPE)) return false;


    const questionId = Number(consumptionIncidenceQuestion.id);

    const response = answers.get(questionId) || [];

    if (!response.length) {
        return {isInValid : false , text : ""};
    }


    // Determine if the question is mandatory
    const isMandatory = Number(consumptionIncidenceQuestion.is_mandatory) === 1;

    const totalValue = addNumberValue(response.map(_ => Number(get(_, "percentage", 0))));
     const anyOtherOption = response.find(_ => Number(_.option_type) === SURVEY_OPTION_TYPES.ANY_OTHER);
        if(anyOtherOption && Number(get(anyOtherOption , "percentage" , 0)) > 0 && !get(anyOtherOption, "value", false)) return {isInValid : true , text : "Please specify the other item."};
    if (isMandatory) {
        // If it's a mandatory consumption incidence  and not all values are equal to 100
        if (
            totalValue !== 100
        ) {
            return {isInValid : true , text : "All option percentages must add up to 100%. Please adjust the sliders."};
        }
    } else {
        if (
            totalValue > 0 && totalValue !== 100
        ) {
            return {isInValid : true , text : "All option percentages must add up to 100%. Please adjust the sliders."};
        }
    }

   return {isInValid : false , text : ""};
};

